// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
  color: rgb(107, 107, 107);
}

.main .Title, .main .numbers, .main .nb {
  color: rgb(40, 40, 40);
}

.icon {
  border-radius: 150px;
  width: 200px;
  height: 200px;
  background-color: #00619b;
  color: white;
}

.numbers {
  padding-top: 25px;
  font-size: 250%;
  font-weight: bold;
  width: 100%;
  text-align: center;
}

.Title {
  font-size: 18px;
  font-weight: bold;
  color: #055C8D !important;
  height: 10%;
}

.status {
  text-align: center;
  font-size: 20px;
}

.c-1 {
  min-height: 10%;
  padding: 20px;
  width: 98% !important;
  margin-top: 2%;
}

.c-2 {
  height: 60%;
  padding-right: 25px;
  margin-bottom: 4%;
}

.c-3 {
  height: 20%;
  padding: 10px;
}

.statuses {
  width: 32%;
  padding-top: 50px;
  cursor: pointer;
}

@media (max-width: 1536px) {
  .icon {
    width: 200px !important;
    height: 200px !important;
  }
  .status {
    font-size: 16px;
  }
}
.description {
  font-size: 14px;
}

.note-font {
  font-size: 16px;
  color: red;
}

.la-8x {
  font-size: 6em;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
